import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-ff867730"), n = n(), _popScopeId(), n);
var _hoisted_1 = ["id"];
var _hoisted_2 = ["id", "data-cy", "checked", "disabled"];
var _hoisted_3 = ["for"];
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxBtn',
  props: {
    id: {},
    inputClass: {
      default: ""
    },
    inline: {
      type: Boolean,
      default: false
    },
    label: {
      default: ""
    },
    labelClass: {
      default: ""
    },
    isValid: {
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    containerId: {
      default: ""
    },
    containerClass: {
      default: ""
    },
    handleLabelClick: {
      type: Boolean,
      default: true
    }
  },
  emits: ["click", "change", "update:modelValue"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var handleChange = () => {
      emits("change", {
        id: props.id,
        label: props.label,
        checked: !props.modelValue
      });
      emits("update:modelValue", !props.modelValue);
    };
    var handleClick = () => {
      emits("click");
      if (!props.handleLabelClick) return;
      //Syncing the checkbox visually
      emits("change", {
        id: props.id,
        label: props.label,
        checked: !props.modelValue
      });
      emits("update:modelValue", !props.modelValue);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: _ctx.containerId,
        class: _normalizeClass(["tw-block tw-group hover:tw-cursor-pointer tw-relative tw-pl-25px", [{
          'tw-inline-flex tw-items-center tw-mr-4': _ctx.inline
        }, {
          'tw-py-10px': !_ctx.inline && !_ctx.$attrs['wrapper-margin-y']
        }, _ctx.$attrs['wrapper-margin-y'], _ctx.containerClass]]),
        onClick: _withModifiers(handleClick, ["stop", "prevent"])
      }, [_createElementVNode("input", {
        id: _ctx.id,
        ref: "checkbox",
        "data-cy": _ctx.$attrs['data-cy'],
        class: _normalizeClass(["checked:tw-bg-center checked:tw-bg-no-repeat tw-w-4 tw-h-4 tw-border tw-border-solid tw-border-w-secondary tw-appearance-none tw-rounded-3xs group-hover:tw-cursor-pointer tw-absolute tw-left-0 tw-bg-white", [{
          '!tw-border-w-danger': _ctx.isValid === false
        }, _ctx.inputClass, _ctx.isValid === false ? 'checked-bg-invalid' : 'checked-bg']]),
        type: "checkbox",
        checked: _ctx.$attrs.checked || _ctx.modelValue,
        disabled: _ctx.$attrs.disabled,
        onChange: _cache[0] || (_cache[0] = _withModifiers($event => handleChange($event), ["stop", "prevent"])),
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => emits('click'), ["stop"]))
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2), _renderSlot(_ctx.$slots, "label", {}, () => [_createElementVNode("label", {
        class: _normalizeClass(["tw-pl-10px group-hover:tw-cursor-pointer", [_ctx.labelClass, {
          'tw-text-w-danger': _ctx.isValid === false
        }]]),
        for: _ctx.id
      }, _toDisplayString(_ctx.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_3), _ctx.$attrs.required ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["required after:tw-content-['*']", [_ctx.isValid !== false ? 'after:tw-text-w-primary' : 'after:tw-text-w-danger']])
      }, null, 2 /* CLASS */)) : _createCommentVNode("v-if", true)])], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
});